import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

export const StyledArrowBack = ({ bigSlider, ...rest }) => <IoIosArrowBack {...rest} />;

export const StyledArrowForward = ({ bigSlider, ...rest }) => <IoIosArrowForward {...rest} />;
